import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import ReactTableColumnSwitcherHelper from '@Components/Results/services/react-table-columns-switcher-helper.service'

export default class TableHeaderComponent extends React.PureComponent {

  render() {
    const {
      getRef,
      headers,
      children,
      className,
      staticColumns,
      showHiddenColumns,
    } = this.props;

    return (
      <thead className={className} ref={getRef}>
        {children}
        <tr className='auto-resize'>
          {headers.map(header => (
            <th
              key={header.id}
              scope='col'
              colSpan={header.colspan ? header.colspan : 1}
              className={`column-${header.cssid} ${header.id === 'paureus' ? 'px-header' : ''} `}>
              {!staticColumns && (
                <a className='show-more' onClick={showHiddenColumns}>
                  {ReactTableColumnSwitcherHelper.getHiddenColumnsAmount(this.props.headers)}...
                </a>
              )}
              <InnerHTML tag="span" html={header.title} />
            </th>
          ))}
        </tr>
      </thead>
    );
  }
}

TableHeaderComponent.propTypes = {
  className: PropTypes.string.isRequired,
  getRef: PropTypes.object,
  headers: PropTypes.array.isRequired,
  showHiddenColumns: PropTypes.func.isRequired,
};

TableHeaderComponent.defaultProps = {
  getRef: React.createRef(),
};
